import type { InitialiseResponse } from './ownable.dtos';
import { Initialise } from './ownable.dtos';
import ServiceStackGateway from './service-stack';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class InitialiseAPI {
  static initialise = () => {
    const request = new Initialise();

    return ServiceStackGateway.get<InitialiseResponse>(request);
  };
}
